import store from '@/store'
import router, { resetRouter } from '@/router'

let logoutRequest = null

export default function logout() {
    if (logoutRequest) return logoutRequest

    if (typeof localStorage !== 'undefined') {
        try {
            localStorage.removeItem('user')
            localStorage.removeItem('menus')
        } catch (error) {
            // Clear in-memory authentication even when browser storage is unavailable.
        }
    }
    store.commit('auth/clearSession')

    logoutRequest = Promise.resolve()
        .then(() => {
            resetRouter()
            if (router.currentRoute.path !== '/login') return router.replace('/login').catch(() => {})
        })
        .finally(() => {
            logoutRequest = null
        })

    return logoutRequest
}
